import { request } from '@umijs/max';
import { LoginParams, LoginResultData, TenantAuthAccount } from '../TenantTypings';

export namespace TenantPassport {
  /**
   * @summary 登录
   * @secure
   */
  export const login = async (data: LoginParams, params: { [key: string]: any } = {}) => {
    return request<LoginResultData>(`/tenant/passport/login`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 注销登录
   * @secure
   */
  export const logout = async (params: { [key: string]: any } = {}) => {
    return request<boolean>(`/tenant/passport/logout`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取登录信息
   * @secure
   */
  export const auth = async (params: { [key: string]: any } = {}) => {
    return request<TenantAuthAccount>(`/tenant/passport/auth`, {
      method: 'GET',
      ...params,
    });
  };
}

export default TenantPassport;

export const login = TenantPassport.login;
export const logout = TenantPassport.logout;
export const auth = TenantPassport.auth;
